import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelTapeWithQuestionMark: FC<SvgIconProps> = ({ viewBox = '0 0 255 169', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      opacity=".6"
      d="M131.037 154.283l9.765-1.848-17.498-9.178-9.624 1.818 17.357 9.208z"
      fill="url(#parcel_tape_with_question_mark_paint0_linear)"
    />
    <path
      opacity=".6"
      d="M171.507 146.565l33.669-3.963-21.336-7.003-25.258 5.275 12.925 5.691z"
      fill="url(#parcel_tape_with_question_mark_paint1_linear)"
    />
    <path
      opacity=".6"
      d="M79.22 142.155l25.231-5.275-42.813-22.468-25.259 5.275 42.842 22.468z"
      fill="url(#parcel_tape_with_question_mark_paint2_linear)"
    />
    <path d="M104.451 65.482l75.241-14.244-42.813-22.468-75.24 14.244 42.812 22.468z" fill="#624508" />
    <path d="M81.648 30.111l75.24-14.244-20.009 12.903-75.24 14.244L81.647 30.11z" fill="#C39000" />
    <path d="M167.387 65.959l12.305-14.72-42.813-22.469-12.333 14.69 42.841 22.499z" fill="#624508" />
    <path d="M104.451 65.483l35.447.923-42.813-22.468-35.447-.924 42.813 22.468z" fill="#996A0D" />
    <path d="M104.451 65.482l75.241-14.243-17.357-17.7-75.24 14.243 17.356 17.7z" fill="#FDDE84" />
    <path d="M104.451 65.483v71.397l-42.813-22.468V43.014l42.813 22.468z" fill="#C39000" />
    <path d="M104.451 65.482v71.398l75.241-14.244V51.238l-75.241 14.244z" fill="#FCCE09" />
    <path
      d="M213.446 115.276c-.114 5.543-2.123 10.855-5.655 14.957s-8.35 6.717-13.565 7.363c-2.429.393-4.91.224-7.271-.496a16.686 16.686 0 01-6.4-3.676 17.85 17.85 0 01-4.345-6.176 18.723 18.723 0 01-1.485-7.532c.114-5.542 2.122-10.854 5.654-14.956 3.533-4.102 8.35-6.717 13.565-7.363a16.07 16.07 0 017.271.496 16.688 16.688 0 016.401 3.676 17.853 17.853 0 014.345 6.176 18.755 18.755 0 011.485 7.531z"
      fill="#9E7549"
    />
    <path d="M194.283 141.082l-10.866-5.632 8.947-.388 1.919 6.02z" fill="#6B4C22" />
    <path d="M203.737 99.065l10.358 5.364-7.479 2.414-2.879-7.778z" fill="#9E7549" />
    <path
      d="M223.38 120.55c-.146 5.545-2.186 10.847-5.744 14.927-3.559 4.081-8.395 6.664-13.617 7.273-2.42.375-4.889.192-7.236-.538a16.693 16.693 0 01-6.359-3.685 17.87 17.87 0 01-4.315-6.157 18.74 18.74 0 01-1.478-7.499c.145-5.544 2.185-10.846 5.744-14.927 3.558-4.08 8.395-6.664 13.616-7.273a16.069 16.069 0 017.236.538 16.688 16.688 0 016.359 3.686 17.834 17.834 0 014.315 6.157c1 2.357 1.505 4.915 1.479 7.498z"
      fill="#BC9361"
    />
    <path
      d="M218.893 121.057c-.113 4.258-1.68 8.33-4.414 11.463-2.734 3.133-6.449 5.116-10.46 5.582a12.412 12.412 0 01-5.556-.448 12.883 12.883 0 01-4.875-2.852 13.784 13.784 0 01-3.306-4.737 14.465 14.465 0 01-1.136-5.76c.112-4.258 1.68-8.33 4.414-11.463 2.734-3.133 6.449-5.116 10.459-5.582a12.401 12.401 0 015.557.448c1.8.569 3.463 1.542 4.875 2.851a13.803 13.803 0 013.306 4.737 14.473 14.473 0 011.136 5.761z"
      fill="#E5E5E5"
    />
    <path
      d="M193.267 113.13c2.737-3.325 6.552-5.45 10.696-5.959a12.403 12.403 0 015.557.447c1.8.57 3.462 1.542 4.874 2.852a13.766 13.766 0 013.306 4.737 14.45 14.45 0 011.136 5.76 16.757 16.757 0 01-.818 5.185"
      fill="#C9C9C9"
    />
    <path
      d="M206.023 117.481a10.525 10.525 0 00-1.512-5.535 9.74 9.74 0 00-4.132-3.762c-2.996 1.134-5.635 3.125-7.62 5.751-2.264 2.931-3.518 6.588-3.556 10.37a14.98 14.98 0 00.931 5.364c1.547.616 3.21.841 4.854.656 2.998-.374 5.767-1.88 7.795-4.241 2.028-2.36 3.179-5.416 3.24-8.603z"
      fill="#fff"
    />
    <path d="M140.802 152.435l39.68-7.569-16.341-9.327-40.837 7.718 17.498 9.178z" fill="#9E7549" />
    <path
      d="M187.622 135.271a9.609 9.609 0 01-.916 4.73 9.038 9.038 0 01-3.063 3.584 13.188 13.188 0 01-3.217 1.281l-16.285-9.237 3.726-.805a7.622 7.622 0 004.031-1.025 8.167 8.167 0 002.996-3.028c.684-1.901.831-3.971.423-5.959l12.305 10.459z"
      fill="#9E7549"
    />
    <path d="M71.855 158.425l31.75-6.02-31.468-16.419-31.778 6.02 31.496 16.419z" fill="#EFEFEF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.956 149.396l5.024 2.562 16.453-2.741-5.023-2.563-16.454 2.742zM52.156 142.363l4.233 2.205 16.453-2.741-4.261-2.176-16.425 2.712zM61.102 146.923l2.089 1.072 16.425-2.741-2.06-1.043-16.454 2.712zM91.836 151.482l-2.117-.954-16.453 2.742 2.145 1.073 16.425-2.861zM58.675 145.7l.847.447 16.453-2.741-.846-.447-16.454 2.741z"
      fill="#000"
    />
    <path
      d="M140.263 95.813c0-5.963 6.621-10.223 6.835-16.825 0-3.834-2.35-4.899-6.195-4.26-4.272.852-6.408 2.556-7.476 3.408-.213-3.195-.213-4.899-.427-8.094 1.495-.852 5.554-2.768 10.467-3.62 7.903-1.491 14.311.852 14.311 8.945 0 8.732-8.758 15.122-8.758 20.233v1.065c-3.417.64-5.126.852-8.544 1.491-.213-1.065-.213-1.49-.213-2.343zm-.428 6.816c3.632-.639 5.554-.852 9.185-1.704v9.584c-3.631.639-5.553 1.065-9.185 1.491v-9.371z"
      fill="#C39000"
    />
    <defs>
      <linearGradient
        id="parcel_tape_with_question_mark_paint0_linear"
        x1="125.844"
        y1="151.631"
        x2="128.886"
        y2="146.014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1860E" stopOpacity="0" />
        <stop offset=".21" stopColor="#fff" stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="parcel_tape_with_question_mark_paint1_linear"
        x1="177.107"
        y1="142.808"
        x2="179.061"
        y2="135.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <linearGradient
        id="parcel_tape_with_question_mark_paint2_linear"
        x1="63.444"
        y1="132.649"
        x2="70.88"
        y2="117.616"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
